export default {
    hairline: 100,
    thin: 200,
    light: 300,

    // normal and regular are the same weight, but we want to support both names for ease of use
    // normal old token name and regular new token name
    normal: 400,
    regular: 400,

    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
}
